import { useEffect, useRef } from "react";
import useUrlParams from "./useUrlParams";
import { initializeFiltersFromUrl } from "../redux/slices/openData/openDataFiltersSlice";
import { getIndicators, getSearchOfIndicators } from "../redux/slices/openData/openDataThunk";
import { LIMIT_PAGINATION_OPEN_DATA } from "../utils/const";
import { useAppDispatch } from "../redux/hooks";

//Se utiliza en datos abiertos
export const useUrlFiltersInitialization = () => {
    const dispatch = useAppDispatch();
    const hasInitialized = useRef(false);
    const { getParam, getMultipleParams } = useUrlParams();

    const getIdsFromUrl = (param: string): string[] | undefined => {
        const ids = getParam(param)?.split(',').map(id => id).filter(id => id !== undefined);
        return ids && ids.length > 0 ? ids : undefined;
    };

    useEffect(() => {
        if (hasInitialized.current) return;

        hasInitialized.current = true;

        const urlFilters = {
            derechos: getMultipleParams('derechos')?.filter(Boolean),
            tiposIndicadores: getMultipleParams('type')?.filter(Boolean),
            dimensiones: getMultipleParams('dimensiones')?.filter(Boolean),
            ods: getMultipleParams('ods')?.filter(Boolean),
            priorityGroups: getMultipleParams('priorityGroups')?.filter(Boolean),
            variables: getMultipleParams('variables')?.filter(Boolean)
        };

        const filtersToInitialize = Object.fromEntries(
            Object.entries(urlFilters).filter(([_, value]) => value?.length > 0)
        );

        if (Object.keys(filtersToInitialize).length > 0) {
            dispatch(initializeFiltersFromUrl(filtersToInitialize));
        }

        const page = Math.max(1, parseInt(getParam('page') || '1', 10));
        const limit = Math.max(1, parseInt(getParam('limit') || LIMIT_PAGINATION_OPEN_DATA.toString(), 10));

        dispatch(getIndicators({
            page,
            limit,
            indicatorId: getParam('indicatorID') || undefined,
            derechos: urlFilters.derechos,
            typeIndicator: urlFilters.tiposIndicadores,
            dimensiones: urlFilters.dimensiones,
            ods: getIdsFromUrl('odsId'),
            gruposPrioritarios: getIdsFromUrl('priorityGroupsId'),
            variables: urlFilters.variables
        }));
    }, [dispatch]);
};
